import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntitySponsor } from "../../entity/EntitySponsor";

export class DtoSponsorsGetReq extends EntitySponsor {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_sponsor_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
